/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'

import router from '@/router'
// import axios from 'axios'
// import auth from '@/auth/authService'
// import acl from '@/acl/acl'

export default {
  loginAttempt ({ dispatch }, payload) {
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    }
    dispatch('login', newPayload)
  },


  // JWT
  loginJWT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(({ data }) => {
          if (data) {
            if (data && data.user) {
              localStorage.setItem('accessToken', data.token)
              localStorage.setItem('exp', data.exp * 1000)
              commit('UPDATE_USER_INFO', {
                ...data.user,
                uid: data.user.id,
                displayName: data.user.name || data.user.user,
                userRole: data.user.role,
                email: data.user.email,
                gender: data.user.gender
              }, {root: true})
              commit('SET_BEARER', data.token)
              // router.push(router.currentRoute.query.to || '/')
              resolve(data)
            } else {
              localStorage.setItem('error', 'auth fail')
              reject({ message:'Invalid email and password' })
            }
          } else {
            localStorage.setItem('error', 'auth fail')
            reject({ message:'Invalid email and password' })
          }
        })
        .catch(error => {
          localStorage.setItem('error', error.message)
          reject(error)
        })
    })
  },

  registerUserJWT ({ commit }, payload) {
    const { business_name, contact_name, email, password, confirmPassword } = payload.userDetails
    return new Promise((resolve, reject) => {
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }
      jwt.registerUser(business_name, contact_name, email, password)
        .then(response => {
          router.push(router.currentRoute.query.to || '/login')
          localStorage.setItem('accessToken', response.data.token)
          commit('UPDATE_USER_INFO', {
            ...response.data.user,
            uid: response.data.user.id,
            displayName: response.data.user.name || response.data.user.user,
            userRole: response.data.user.role
          }, {root: true})
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
